import { Amplify, Storage } from "aws-amplify";
import { config } from "../configs";
import { getSessionToken } from "./getToken";
import axios from "axios";
import { getServiceTypesForOrg, getServiceOptions } from ".";
import { processProcedure } from "./processProcedure";
Amplify.configure(config);

export const createProcedure = async (
  attributes,
  orgID,
  serviceTypeID,
  serviceOptionID
) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const URL = `${config.baseURL}/servicetypes/${serviceTypeID}/serviceoptions/${serviceOptionID}/procedures`;
      const { data } = await axios({
        method: "POST",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgID,
          typeId: serviceTypeID,
          optionId: serviceOptionID,
        },
        url: URL,
        data: {
          procedure: {
            ...processProcedure(attributes),
            serviceTypeId: serviceTypeID,
            serviceOptionId: serviceOptionID,
          },
          published: attributes.status === "COMPLETED" ? true : false,
        },
      });
      console.log(data);
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

export const getProcedures = async (serviceTypeID, serviceOptionID) => {
  const org = window?.localStorage?.getItem("REDUX_CURRENT_ORGANIZATION")
    ? JSON.parse(window?.localStorage?.getItem("REDUX_CURRENT_ORGANIZATION"))
    : undefined;
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      let serviceTypes = [];
      let serviceOptions = [];
      try {
        // console.log("org", org.id)
        serviceTypes = await getServiceTypesForOrg(org.id);
        if (serviceTypes?.length) {
          // console.log("serviceTypes", serviceTypes[0]);
          serviceOptions = serviceTypes[0]
            ? await getServiceOptions(serviceTypes[0]?.system_id, org.id)
            : [];
          // console.log("serviceOptions", serviceOptions[0]);
        }
      } catch (error) {
        console.log(error);
      }
      const URL = `${config.baseURL}/servicetypes/${serviceTypes[0]?.system_id}/serviceoptions/${serviceOptions[0]?.system_id}/procedures`;
      const { data } = await axios({
        method: "GET",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: org?.id,
          typeId: serviceTypes[0]?.system_id,
          optionId: serviceOptions[0]?.system_id,
        },
        url: URL,
      });
      // console.log();

      // eslint-disable-next-line no-loop-func
      const newData = [
        ...data.map((item) => ({
          ...item,
          orgId: org.id,
          screen_name: org.screen_name,
          name: org.name,
        })),
      ];
      resolve({
        data: newData.map((item) => ({
          ...item.procedure,
          system_id: item.system_id,
          orgId: item.orgId,
          organization: item?.screen_name || item?.name,
        })),
      });
    } catch (error) {
      // console.log("Here", error);
      reject(error);
    }
  });
};

export const getProcedure = async (
  procedureID,
  orgID,
  serviceTypeID,
  serviceOptionID
) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const URL = `${config.baseURL}/servicetypes/${serviceTypeID}/serviceoptions/${serviceOptionID}/procedures/${procedureID}`;
      const { data } = await axios({
        method: "GET",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgID,
          typeId: serviceTypeID,
          optionId: serviceOptionID,
          procedureId: procedureID,
        },
        url: URL,
      });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

export const updateProcedure = async (
  attributes,
  orgID,
  serviceTypeID,
  serviceOptionID,
  procedureID
) => {
  // console.log("attributes", attributes);
  // debugger;
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const URL = `${config.baseURL}/servicetypes/${serviceTypeID}/serviceoptions/${serviceOptionID}/procedures/${procedureID}`;
      const { data } = await axios({
        method: "PATCH",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgID,
          typeId: serviceTypeID,
          optionId: serviceOptionID,
          procedureId: procedureID,
        },
        url: URL,
        data: {
          procedure: {
            ...processProcedure(attributes),
            serviceTypeId: serviceTypeID,
            serviceOptionId: serviceOptionID,
          },
          published: attributes.status === "COMPLETED" ? true : false,
        },
      });
      // console.log("attributes", attributes, "data", data);
      resolve(data);
    } catch (error) {
      // console.log("Here", error);
      reject(error);
    }
  });
};

export const uploadJSON = (obj, userInfo, onUpload) => {
  const url = `work-instructions/${obj.id}.json`;
  return new Promise((resolve, reject) => {
    Storage.put(url, JSON.stringify(obj), {
      level: "private",
      bucket: config.workInstructionBucket,
      contentType: "application/json",
    })
      .then((result) => {
        // console.log("upload_file success", result);
        return resolve({ payload: "SUCCESS", url, id: obj.id });
      })
      .catch((err) => {
        console.log(" error ", err);
        reject({ error: err });
      });
  });
};

export const getJSON = async (key) => {
  return new Promise((resolve, reject) => {
    Storage.configure({ level: "private" });
    // Storage.get(`work-instructions/${id}`);
    Storage.get(key, {
      level: "private",
      bucket: config.workInstructionBucket,
    })
      .then((result) => {
        // console.log("upload_file success", result);
        // console.log("Decode result", result);
        return resolve({ result });
      })
      .catch((err) => {
        console.log(" error ", err);
        reject({ error: err });
      });
  });
};

export const getData = async (URL) => {
  return new Promise(async function (resolve, reject) {
    try {
      const { status, data } = await axios({
        method: "GET",
        url: URL,
      });
      if (status === 200) resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

export const listJSON = async () => {
  return new Promise((resolve, reject) => {
    Storage.list("work-instructions/", {
      level: "private",
      bucket: config.workInstructionBucket,
    })
      .then(async (result) => {
        const data = await Promise.all(
          result.map(async (item) => {
            const newData = await getJSON(item.key);

            const newData2 = await getData(newData.result);
            return newData2;
          })
        );
        return resolve({ data: data || [] });
      })
      .catch((err) => {
        console.log(" error ", err);
        reject({ error: err });
      });
  });
};

export const deleteJSON = async (id) => {
  // console.log(url);
  return new Promise((resolve, reject) => {
    Storage.remove(`work-instructions/${id}.json`, {
      level: "private",
      bucket: config.workInstructionBucket,
    })
      .then(async (result) => {
        // console.log(result);
        return resolve(result);
      })
      .catch((err) => {
        console.log(" error ", err);
        reject({ error: err });
      });
  });
};
